<!-- 
  ReviewEventSummary.vue
  후기 이벤트 요약 페이지
  
  - 후기 이벤트의 전용 요약 정보 표시
-->
<template>
  <div class="container-fluid col-sm-12 col-xs-12">
    <div style="margin-top: 28px"></div>
    <!-- 페이지 헤더 영역 -->
    <div class="card-header pb-0 col-sm-12 d-flex">
      <div class="col-sm-12 col-xs-12">
        <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
          <div class="title-row">
            <div>
              <h1 class="fw-bold page-title">
                후기 이벤트 요약
              </h1>
              <span class="pageDesc">2025 여름 후기 이벤트의 요약 정보를 확인할 수 있습니다.</span>
            </div>
            <div class="header-actions">
              <div class="event-filter-left">
                <div class="event-filter-row">
                  <label class="label" style="margin-right: 20px;">이벤트 캠페인 선택</label>
                  <a-select
                    v-model:value="selectedEventId"
                    class="event-select"
                    @change="handleEventChange"
                  >
                    <a-select-option value="dummyEventId">
                      2024 여름 이벤트(2024/08/01 ~ 2024/09/30)
                    </a-select-option>
                    <a-select-option value="dummyEventId2">
                      2024 설문이벤트(2024/09/02 ~ 2024/09/30)
                    </a-select-option>
                    <a-select-option value="dummyEventId3">
                      2025 여름 후기 이벤트 (2025-06-20 ~ 2025-08-31)
                    </a-select-option>
                    <a-select-option :value="currentEventId">
                      스마일 카드 공유 이벤트 (2025-07-03 ~ 2025-08-31)
                    </a-select-option>
                  </a-select>
                </div>
              </div>
              <a-button class="excel-button" @click="downloadExcel">
                <i class="fa fa-file-excel" style="margin-right: 5px"></i> 엑셀 다운로드
              </a-button>
              <a-button class="back-button" @click="goBack">
                <i class="fa fa-arrow-left" style="margin-right: 5px"></i> 뒤로가기
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 콘텐츠 영역 -->
    <div class="card-body px-0 pt-3 pb-2">
      <div class="card content-wrap-card">
        <div class="section-header">
          <div class="section-title">
            <i class="fa fa-chart-line" style="margin-right: 8px"></i>후기 이벤트 요약
          </div>
        </div>
        
        <div class="content-section" v-if="!loading">
          <!-- 후기 이벤트 전용 통계 -->
          <div class="review-summary-section">
            <div class="stats-title">
              <i class="fa fa-chart-bar"></i>
              <span>후기 이벤트 주요 성과</span>
            </div>
            <div class="stats-subtitle">후기 작성부터 마케팅 효과까지의 전체 현황</div>
            
            <div class="review-stats-row">
              <div 
                v-for="stat in reviewEventStats" 
                :key="stat.key"
                :class="['stat-card', stat.colorClass]"
              >
                <div class="stat-number">
                  {{ stat.value.toLocaleString() }}{{ stat.unit }}
                </div>
                <div class="stat-desc">{{ stat.label }}</div>
                <div class="stat-percent">{{ stat.description }}</div>
              </div>
            </div>
          </div>


          <!-- 후기 유형별 분석 -->
          <div class="review-type-analysis-section">
            <div class="section-header">
              <h3 class="section-title">후기 유형별 분석</h3>
              <p class="section-desc">작성된 후기의 유형별 현황과 품질 분석</p>
            </div>
            
            <div class="analysis-cards-row">
              <!-- 수술별 응모자 수 -->
              <div class="analysis-card">
                  <div class="card-header quality-header">
                    <h4 class="card-title">
                      <i class="fa fa-eye"></i>
                      스마일 환자 수술별 후기 수
                    </h4>
                  </div>
                <div class="card-content">
                  <a-table 
                    :dataSource="reviewQualityStats" 
                    :columns="qualityColumns"
                    :pagination="false"
                    size="small"
                  />
                </div>
              </div>

              <!-- 만족도 점수 분포 -->
              <div class="analysis-card">
                <div class="card-header rating-header">
                  <h4 class="card-title">
                    <i class="fa fa-chart-pie"></i>
                    수술별 만족도 점수 분포
                  </h4>
                </div>
                <div class="card-content">
                  <a-table 
                    :dataSource="ratingDistribution" 
                    :columns="ratingColumns"
                    :pagination="false"
                    size="small"
                  />
                </div>
              </div>
              
              <!-- 연령대별 분포 -->
              <div class="analysis-card">
                <div class="card-header length-header">
                  <h4 class="card-title">
                    <i class="fa fa-users"></i>
                    스마일 환자 응모자 연령대 및 만족도
                  </h4>
                </div>
                <div class="card-content">
                  <a-table 
                    :dataSource="reviewLengthStats" 
                    :columns="lengthColumns"
                    :pagination="false"
                    size="small"
                  />
                </div>
              </div>

              
              <!-- 수술 경과 시점별 후기 수 -->
              <div class="analysis-card">
                <div class="card-header period-header">
                  <h4 class="card-title">
                    <i class="fa fa-calendar"></i>
                    수술 경과 시점별 후기 수, 만족도
                  </h4>
                </div>
                <div class="card-content">
                  <a-table 
                    :dataSource="periodStats" 
                    :columns="periodColumns"
                    :pagination="false"
                    size="small"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- 병원별 후기 현황 -->
          <div class="hospital-review-section">
            <div class="section-header-simple">
              <h3 class="section-title">
                <i class="fa fa-hospital"></i>
                스마일 환자 병원별 후기 수 및 만족도 점수
              </h3>
            </div>
            
            <div class="hospital-table-content">
              <a-table 
                :dataSource="hospitalReviewStats" 
                :columns="hospitalReviewColumns"
                :pagination="false"
                size="middle"
                :scroll="{ x: 'max-content' }"
                class="hospital-review-table"
              />
            </div>
          </div>
        </div>
        
        <!-- 로딩 상태 -->
        <div class="content-section" v-if="loading">
          <div class="loading-state">
            <a-spin size="large" />
            <p>후기 이벤트 데이터를 불러오는 중입니다...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';

export default {
  name: "ReviewEventSummary",
  setup() {
    const router = useRouter();
    
    // 상태 변수
    const loading = ref(false);
    const selectedEventId = ref('dummyEventId3');
    const currentEventId = ref(''); // 실제 이벤트 ID
    if(process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
        currentEventId.value = '688c74fa9bad033589258352'; // 개발
    } else if (process.env.NODE_ENV === 'stage') {
        currentEventId.value = '6860e05ccca7ad7006779b45'; // 스테이징
    } else {
        currentEventId.value = '6864f97c93111a68978dc3f5'; // 운영
    }
    // 후기 이벤트 주요 성과 데이터
    const reviewEventStats = ref([
      {
        key: 'totalParticipants',
        value: 11079,
        unit: '건',
        label: '총 후기 수',
        description: '스마일 + 스마일 프로',
        colorClass: 'purple'
      },
      {
        key: 'avgRating',
        value: 4.80,
        unit: '점',
        label: '전체 평균 만족도',
        description: '5점 만점 기준',
        colorClass: 'blue'
      },
      {
        key: 'highRating',
        value: 10745,
        unit: '건',
        label: '4점 이상 후기',
        description: '스마일 97.0% 스마일 프로 97.1%',
        colorClass: 'green'
      },
      {
        key: 'smileCount',
        value: 8487,
        unit: '건',
        label: '스마일 후기',
        description: '전체의 77%',
        colorClass: 'orange'
      },
      {
        key: 'smileProCount',
        value: 2592,
        unit: '건',
        label: '스마일 프로 후기',
        description: '전체의 23%',
        colorClass: 'purple-light'
      },
      {
        key: 'youngUsers',
        value: 52.88,
        unit: '%',
        label: '30세 미만 비율',
        description: '젊은 고객층 집중',
        colorClass: 'cyan'
      }
    ]);
    
    
    // 수술별 후기 수 (실제 데이터)
    const reviewQualityStats = ref([
      { key: '1', quality: '스마일', count: 8487, ratio: 77.0, satisfaction: 4.81 },
      { key: '2', quality: '스마일 프로', count: 2592, ratio: 23.0, satisfaction: 4.81 },
      { key: '3', quality: '합계', count: 11079, ratio: 100.0, satisfaction: '' }
    ]);

    const qualityColumns = ref([
      { title: '수술별', dataIndex: 'quality', key: 'quality', width: 140, align: 'center' },
      { title: '응모자 수', dataIndex: 'count', key: 'count', align: 'right',
        customRender: ({ text }) => text.toLocaleString() },
      { title: '비율', dataIndex: 'ratio', key: 'ratio', align: 'right',
        customRender: ({ text }) => `${text}%` },
      { title: '만족도 점수', dataIndex: 'satisfaction', key: 'satisfaction', width: 110, align: 'center',
        customRender: ({ text }) => text }
    ]);
    
    // 연령대별 분포 데이터 (실제 데이터)
    const reviewLengthStats = ref([
      { key: '1', length: '24세 이하', count: 3003, ratio: 27.11, satisfaction: 4.81 },
      { key: '2', length: '25-29세', count: 2855, ratio: 25.77, satisfaction: 4.80 },
      { key: '3', length: '30-34세', count: 2010, ratio: 18.14, satisfaction: 4.83 },
      { key: '4', length: '35-39세', count: 776, ratio: 7.00, satisfaction: 4.83 },
      { key: '5', length: '40세 이상', count: 313, ratio: 2.83, satisfaction: 4.76 },
      { key: '6', length: '연령 입력 없음', count: 2122, ratio: 19.15, satisfaction: 4.80 }
    ]);

    const lengthColumns = ref([
      { title: '연령대', dataIndex: 'length', key: 'length', width: 120, align: 'center' },
      { title: '응모자 수', dataIndex: 'count', key: 'count', align: 'right',
        customRender: ({ text }) => text.toLocaleString() },
      { title: '비율', dataIndex: 'ratio', key: 'ratio', align: 'right',
        customRender: ({ text }) => `${text}%` },
      { title: '만족도 점수', dataIndex: 'satisfaction', key: 'satisfaction', width: 110, align: 'center',
        customRender: ({ text }) => text.toFixed(2) }
    ]);
    
    // 만족도 점수 분포 데이터 (실제 데이터)
    const ratingDistribution = ref([
      { key: '1', rating: '5점', smileCount: 7265, smileRatio: 85.6, smileProCount: 2227, smileProRatio: 85.92 },
      { key: '2', rating: '4점', smileCount: 962, smileRatio: 11.3, smileProCount: 291, smileProRatio: 11.23 },
      { key: '3', rating: '3점', smileCount: 174, smileRatio: 2.1, smileProCount: 42, smileProRatio: 1.62 },
      { key: '4', rating: '2점', smileCount: 34, smileRatio: 0.4, smileProCount: 12, smileProRatio: 0.46 },
      { key: '5', rating: '1점 이하', smileCount: 52, smileRatio: 0.6, smileProCount: 20, smileProRatio: 0.77 },
      { key: '6', rating: '합계', smileCount: 8487, smileRatio: 100, smileProCount: 2592, smileProRatio: 100 }
    ]);

    const ratingColumns = ref([
      { title: '', dataIndex: 'rating', key: 'rating', width: 80, align: 'center' },
      {
        title: '스마일',
        children: [
          { title: '응답자 수', dataIndex: 'smileCount', key: 'smileCount', width: 90, align: 'right',
            customRender: ({ text }) => text.toLocaleString() },
          { title: '응답 비율', dataIndex: 'smileRatio', key: 'smileRatio', width: 90, align: 'right',
            customRender: ({ text }) => `${text}%` }
        ]
      },
      {
        title: '스마일 프로',
        children: [
          { title: '응답자 수', dataIndex: 'smileProCount', key: 'smileProCount', width: 90, align: 'right',
            customRender: ({ text }) => text.toLocaleString() },
          { title: '응답 비율', dataIndex: 'smileProRatio', key: 'smileProRatio', width: 90, align: 'right',
            customRender: ({ text }) => `${text}%` }
        ]
      }
    ]);
    
    // 수술 경과 시점별 후기 수, 만족도 데이터 (실제 데이터)
    const periodStats = ref([
      { key: '1', period: '1개월 미만', smileCount: 107, smileScore: 4.85, smileProCount: 36, smileProScore: 5.00 },
      { key: '2', period: '3개월 미만', smileCount: 454, smileScore: 4.78, smileProCount: 231, smileProScore: 4.79 },
      { key: '3', period: '6개월 미만', smileCount: 331, smileScore: 4.83, smileProCount: 156, smileProScore: 4.79 },
      { key: '4', period: '1년 미만', smileCount: 3135, smileScore: 4.81, smileProCount: 1098, smileProScore: 4.82 },
      { key: '5', period: '1년 이상', smileCount: 4460, smileScore: 4.81, smileProCount: 1071, smileProScore: 4.80 },
      { key: '6', period: '합계', smileCount: 8487, smileScore: '', smileProCount: 2592, smileProScore: '' }
    ]);

    const periodColumns = ref([
      { title: '기간', dataIndex: 'period', key: 'period', width: 80, align: 'center' },
      {
        title: '스마일',
        children: [
          { title: '후기 건 수', dataIndex: 'smileCount', key: 'smileCount', width: 80, align: 'right',
            customRender: ({ text }) => text.toLocaleString() },
          { title: '만족도 점수', dataIndex: 'smileScore', key: 'smileScore', width: 90, align: 'right',
            customRender: ({ text }) => text ? text.toFixed(2) : '' }
        ]
      },
      {
        title: '스마일 프로',
        children: [
          { title: '후기 건 수', dataIndex: 'smileProCount', key: 'smileProCount', width: 80, align: 'right',
            customRender: ({ text }) => text.toLocaleString() },
          { title: '만족도 점수', dataIndex: 'smileProScore', key: 'smileProScore', width: 90, align: 'right',
            customRender: ({ text }) => text ? text.toFixed(2) : '' }
        ]
      }
    ]);
    
    // 병원별 후기 현황 데이터
    const hospitalReviewStats = ref([
      { key: '1', hospitalName: '메트로안과', smileCount: 750, smileProCount: 218, totalCount: 968, ratio: 8.74, avgRating: 4.84 },
      { key: '2', hospitalName: '밝은눈안과 강남', smileCount: 479, smileProCount: 214, totalCount: 693, ratio: 6.26, avgRating: 4.75 },
      { key: '3', hospitalName: '온누리안과병원', smileCount: 435, smileProCount: 203, totalCount: 638, ratio: 5.76, avgRating: 4.73 },
      { key: '4', hospitalName: 'SNU안과', smileCount: 363, smileProCount: 214, totalCount: 577, ratio: 5.21, avgRating: 4.81 },
      { key: '5', hospitalName: '밝은세상안과', smileCount: 243, smileProCount: 247, totalCount: 490, ratio: 4.42, avgRating: 4.86 },
      { key: '6', hospitalName: '밝은누리안과병원', smileCount: 384, smileProCount: 75, totalCount: 459, ratio: 4.14, avgRating: 4.77 },
      { key: '7', hospitalName: '온누리스마일안과의원', smileCount: 324, smileProCount: 103, totalCount: 427, ratio: 3.85, avgRating: 4.82 },
      { key: '8', hospitalName: '비앤빛안과', smileCount: 364, smileProCount: 59, totalCount: 423, ratio: 3.82, avgRating: 4.82 },
      { key: '9', hospitalName: '신세계안과', smileCount: 328, smileProCount: 92, totalCount: 420, ratio: 3.79, avgRating: 4.78 },
      { key: '10', hospitalName: 'GS안과', smileCount: 245, smileProCount: 149, totalCount: 394, ratio: 3.56, avgRating: 4.88 },
      { key: '11', hospitalName: '아이리움안과', smileCount: 219, smileProCount: 166, totalCount: 385, ratio: 3.48, avgRating: 4.80 },
      { key: '12', hospitalName: '서울밝은세상안과', smileCount: 216, smileProCount: 167, totalCount: 383, ratio: 3.46, avgRating: 4.79 },
      { key: '13', hospitalName: '압구정안과의원', smileCount: 164, smileProCount: 193, totalCount: 357, ratio: 3.22, avgRating: 4.82 },
      { key: '14', hospitalName: '인천푸른세상안과의원', smileCount: 232, smileProCount: 23, totalCount: 255, ratio: 2.30, avgRating: 4.82 },
      { key: '15', hospitalName: '삼성스마일안과의원', smileCount: 250, smileProCount: 4, totalCount: 254, ratio: 2.29, avgRating: 4.86 },
      { key: '16', hospitalName: '파티마안과', smileCount: 103, smileProCount: 126, totalCount: 229, ratio: 2.07, avgRating: 4.78 },
      { key: '17', hospitalName: '아이플러스안과의원', smileCount: 171, smileProCount: 56, totalCount: 227, ratio: 2.05, avgRating: 4.84 },
      { key: '18', hospitalName: '더밝은안과의원', smileCount: 204, smileProCount: 0, totalCount: 204, ratio: 1.84, avgRating: 4.87 },
      { key: '19', hospitalName: '강남밝은미소안과', smileCount: 181, smileProCount: 0, totalCount: 181, ratio: 1.63, avgRating: 4.73 },
      { key: '20', hospitalName: '수연세안과의원', smileCount: 136, smileProCount: 44, totalCount: 180, ratio: 1.62, avgRating: 4.87 },
      { key: '21', hospitalName: '광주안과의원', smileCount: 169, smileProCount: 0, totalCount: 169, ratio: 1.53, avgRating: 4.84 },
      { key: '22', hospitalName: '삼성미라클안과의원 강남', smileCount: 131, smileProCount: 37, totalCount: 168, ratio: 1.52, avgRating: 4.79 },
      { key: '23', hospitalName: '새빛안과병원', smileCount: 164, smileProCount: 0, totalCount: 164, ratio: 1.48, avgRating: 4.80 },
      { key: '24', hospitalName: '한길안과병원', smileCount: 118, smileProCount: 39, totalCount: 157, ratio: 1.42, avgRating: 4.76 },
      { key: '25', hospitalName: '강남서울밝은안과', smileCount: 155, smileProCount: 0, totalCount: 155, ratio: 1.40, avgRating: 4.81 },
      { key: '26', hospitalName: '누네빛안과', smileCount: 93, smileProCount: 61, totalCount: 154, ratio: 1.39, avgRating: 4.82 },
      { key: '27', hospitalName: '수정안과', smileCount: 144, smileProCount: 0, totalCount: 144, ratio: 1.30, avgRating: 4.84 },
      { key: '28', hospitalName: '강남조은눈안과', smileCount: 86, smileProCount: 34, totalCount: 120, ratio: 1.08, avgRating: 4.79 },
      { key: '29', hospitalName: '아이시티안과', smileCount: 115, smileProCount: 0, totalCount: 115, ratio: 1.04, avgRating: 4.75 },
      { key: '30', hospitalName: '클리어서울안과', smileCount: 109, smileProCount: 0, totalCount: 109, ratio: 0.98, avgRating: 4.85 },
      { key: '31', hospitalName: '카이안과', smileCount: 95, smileProCount: 11, totalCount: 106, ratio: 0.96, avgRating: 4.76 },
      { key: '32', hospitalName: '김기수수안과의원', smileCount: 92, smileProCount: 0, totalCount: 92, ratio: 0.83, avgRating: 4.83 },
      { key: '33', hospitalName: '삼성미라클안과 천안점', smileCount: 83, smileProCount: 0, totalCount: 83, ratio: 0.75, avgRating: 4.89 },
      { key: '34', hospitalName: '김안과', smileCount: 83, smileProCount: 0, totalCount: 83, ratio: 0.75, avgRating: 4.89 },
      { key: '35', hospitalName: '울산신세계안과', smileCount: 81, smileProCount: 0, totalCount: 81, ratio: 0.73, avgRating: 4.78 },
      { key: '36', hospitalName: '압구정에스앤비안과', smileCount: 81, smileProCount: 0, totalCount: 81, ratio: 0.73, avgRating: 4.73 },
      { key: '37', hospitalName: '센트럴윤길중안과의원', smileCount: 67, smileProCount: 3, totalCount: 70, ratio: 0.63, avgRating: 4.91 },
      { key: '38', hospitalName: '부산성모안과병원', smileCount: 64, smileProCount: 0, totalCount: 64, ratio: 0.58, avgRating: 4.89 },
      { key: '39', hospitalName: '천안나안과', smileCount: 61, smileProCount: 0, totalCount: 61, ratio: 0.55, avgRating: 4.90 },
      { key: '40', hospitalName: '광주스마일안과의원', smileCount: 59, smileProCount: 0, totalCount: 59, ratio: 0.53, avgRating: 4.81 },
      { key: '41', hospitalName: '서울온안과', smileCount: 54, smileProCount: 0, totalCount: 54, ratio: 0.49, avgRating: 4.87 },
      { key: '42', hospitalName: '센텀소중한눈안과', smileCount: 51, smileProCount: 0, totalCount: 51, ratio: 0.46, avgRating: 4.80 },
      { key: '43', hospitalName: '분당연세플러스안과', smileCount: 50, smileProCount: 0, totalCount: 50, ratio: 0.45, avgRating: 4.86 },
      { key: '44', hospitalName: '이지봄안과', smileCount: 47, smileProCount: 0, totalCount: 47, ratio: 0.42, avgRating: 4.94 },
      { key: '45', hospitalName: '예일안과', smileCount: 44, smileProCount: 0, totalCount: 44, ratio: 0.40, avgRating: 4.86 },
      { key: '46', hospitalName: '서울신세계안과', smileCount: 41, smileProCount: 0, totalCount: 41, ratio: 0.37, avgRating: 4.83 },
      { key: '47', hospitalName: 'BGN밝은눈안과병원', smileCount: 23, smileProCount: 16, totalCount: 39, ratio: 0.35, avgRating: 4.54 },
      { key: '48', hospitalName: '눈에미소안과', smileCount: 19, smileProCount: 19, totalCount: 38, ratio: 0.34, avgRating: 4.76 },
      { key: '49', hospitalName: '밝은안과21병원', smileCount: 35, smileProCount: 0, totalCount: 35, ratio: 0.32, avgRating: 4.74 },
      { key: '50', hospitalName: '하나서울안과', smileCount: 35, smileProCount: 0, totalCount: 35, ratio: 0.32, avgRating: 4.89 },
      { key: '51', hospitalName: '에스안과', smileCount: 33, smileProCount: 0, totalCount: 33, ratio: 0.30, avgRating: 4.88 },
      { key: '52', hospitalName: '퍼스트안과', smileCount: 31, smileProCount: 0, totalCount: 31, ratio: 0.28, avgRating: 4.90 },
      { key: '53', hospitalName: '미아서울신세계안과', smileCount: 29, smileProCount: 0, totalCount: 29, ratio: 0.26, avgRating: 4.86 },
      { key: '54', hospitalName: '아이백안과', smileCount: 23, smileProCount: 0, totalCount: 23, ratio: 0.21, avgRating: 5.00 },
      { key: '55', hospitalName: '맑은눈안과', smileCount: 17, smileProCount: 0, totalCount: 17, ratio: 0.15, avgRating: 4.65 },
      { key: '56', hospitalName: '아이러브안과', smileCount: 15, smileProCount: 0, totalCount: 15, ratio: 0.14, avgRating: 4.93 },
      { key: '57', hospitalName: '빛사랑안과', smileCount: 15, smileProCount: 0, totalCount: 15, ratio: 0.14, avgRating: 4.93 },
      { key: '58', hospitalName: 'BGN밝은눈안과', smileCount: 0, smileProCount: 14, totalCount: 14, ratio: 0.13, avgRating: 4.79 },
      { key: '59', hospitalName: '난초꽃피다안과의원', smileCount: 9, smileProCount: 5, totalCount: 14, ratio: 0.13, avgRating: 4.93 },
      { key: '60', hospitalName: '압구정밝은안과', smileCount: 13, smileProCount: 0, totalCount: 13, ratio: 0.12, avgRating: 4.77 },
      { key: '61', hospitalName: '보라안과병원', smileCount: 12, smileProCount: 0, totalCount: 12, ratio: 0.11, avgRating: 4.92 },
      { key: '62', hospitalName: '서울다봄안과의원', smileCount: 11, smileProCount: 0, totalCount: 11, ratio: 0.10, avgRating: 4.36 },
      { key: '63', hospitalName: '서면좋은사람안과', smileCount: 11, smileProCount: 0, totalCount: 11, ratio: 0.10, avgRating: 5.00 },
      { key: '64', hospitalName: 'CK성모안과', smileCount: 9, smileProCount: 0, totalCount: 9, ratio: 0.08, avgRating: 5.00 },
      { key: '65', hospitalName: '수원이안과', smileCount: 8, smileProCount: 0, totalCount: 8, ratio: 0.07, avgRating: 5.00 },
      { key: '66', hospitalName: '푸른안과의원', smileCount: 4, smileProCount: 0, totalCount: 4, ratio: 0.04, avgRating: 4.75 },
      { key: '67', hospitalName: '현탑안과의원', smileCount: 3, smileProCount: 0, totalCount: 3, ratio: 0.03, avgRating: 5.00 },
      { key: '68', hospitalName: '인천퍼스트안과', smileCount: 2, smileProCount: 0, totalCount: 2, ratio: 0.02, avgRating: 4.50 },
      { key: '69', hospitalName: '루원스마일안과', smileCount: 1, smileProCount: 0, totalCount: 1, ratio: 0.01, avgRating: 5.00 },
      { key: '70', hospitalName: '판교연세독수리안과', smileCount: 1, smileProCount: 0, totalCount: 1, ratio: 0.01, avgRating: 5.00 },
      { key: '71', hospitalName: '강남이룸안과', smileCount: 0, smileProCount: 0, totalCount: 0, ratio: 0.00, avgRating: 0.00 },
      { key: '72', hospitalName: '굿모닝성모안과', smileCount: 0, smileProCount: 0, totalCount: 0, ratio: 0.00, avgRating: 0.00 },
      { key: '73', hospitalName: '수원문안과', smileCount: 0, smileProCount: 0, totalCount: 0, ratio: 0.00, avgRating: 0.00 },
      { key: '74', hospitalName: '최안과', smileCount: 0, smileProCount: 0, totalCount: 0, ratio: 0.00, avgRating: 0.00 },
      { key: '75', hospitalName: '청춘안과', smileCount: 0, smileProCount: 0, totalCount: 0, ratio: 0.00, avgRating: 0.00 },
      { key: '76', hospitalName: '김안과병원', smileCount: 0, smileProCount: 0, totalCount: 0, ratio: 0.00, avgRating: 0.00 },
      { key: '77', hospitalName: '하이뷰안과', smileCount: 0, smileProCount: 0, totalCount: 0, ratio: 0.00, avgRating: 0.00 },
      { key: '78', hospitalName: '데미안안과', smileCount: 0, smileProCount: 0, totalCount: 0, ratio: 0.00, avgRating: 0.00 },
      { key: '79', hospitalName: '삼성아이안과', smileCount: 0, smileProCount: 0, totalCount: 0, ratio: 0.00, avgRating: 0.00 }
    ]);

    const hospitalReviewColumns = ref([
      { title: '병원명', dataIndex: 'hospitalName', key: 'hospitalName', width: 200, align: 'center', fixed: 'left' },
      { title: '스마일', dataIndex: 'smileCount', key: 'smileCount', width: 80, align: 'right',
        customRender: ({ text }) => text.toLocaleString() },
      { title: '스마일 프로', dataIndex: 'smileProCount', key: 'smileProCount', width: 100, align: 'right',
        customRender: ({ text }) => text.toLocaleString() },
      { title: '합계', dataIndex: 'totalCount', key: 'totalCount', width: 80, align: 'right',
        customRender: ({ text }) => text.toLocaleString() },
      { title: '응모자 비율', dataIndex: 'ratio', key: 'ratio', width: 100, align: 'right',
        customRender: ({ text }) => `${text.toFixed(2)}%` },
      { title: '만족도 점수', dataIndex: 'avgRating', key: 'avgRating', width: 110, align: 'center',
        customRender: ({ text }) => text > 0 ? text.toFixed(2) : '0.00' }
    ]);
    
    // 이벤트 핸들러
    const handleEventChange = (eventId) => {
      console.log('선택된 이벤트 ID:', eventId);
      selectedEventId.value = eventId;
      
      if (eventId === 'dummyEventId3') {
        // 현재 페이지에서 머물기
        return;
      } else if (eventId === currentEventId.value) {
        // 실제 이벤트 통계 페이지로 이동
        router.push({
          path: '/events-v2/statistics',
          query: { eventId: eventId }
        });
      } else {
        // 다른 더미 이벤트는 기본 대시보드로
        router.push('/events/dashboard');
      }
    };
    
    // 엑셀 다운로드 기능
    const downloadExcel = async () => {
      try {
        // XLSX 파일이 있는 경우 직접 다운로드
        const response = await fetch('/review-event-data.xlsx');
        if (response.ok) {
          const blob = await response.blob();
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = '2025_여름_후기_이벤트_현황.xlsx';
          link.click();
        } else {
          // XLSX 파일이 없으면 CSV 파일 다운로드
          const csvResponse = await fetch('/review-event-data.csv');
          const csvBlob = await csvResponse.blob();
          const link = document.createElement('a');
          link.href = URL.createObjectURL(csvBlob);
          link.download = '2025_여름_후기_이벤트_현황.csv';
          link.click();
        }
      } catch (error) {
        console.error('다운로드 중 오류가 발생했습니다:', error);
        // 현재 데이터로 CSV 생성
        const csvContent = hospitalReviewStats.value.map(row => 
          `${row.hospitalName},${row.smileCount},${row.smileProCount},${row.totalCount},${row.ratio.toFixed(2)},${row.avgRating.toFixed(2)}`
        ).join('\n');
        const header = '병원명,스마일,스마일 프로,전체,비율(%),평균만족도\n';
        const blob = new Blob([header + csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = '2025_여름_후기_이벤트_현황.csv';
        link.click();
      }
    };
    
    const goBack = () => {
      router.go(-1);
    };
    
    // 마운트 시 실행
    onMounted(() => {
      console.log('후기 이벤트 요약 페이지가 마운트되었습니다.');
    });
    
    return {
      loading,
      selectedEventId,
      currentEventId,
      reviewEventStats,
      reviewQualityStats,
      qualityColumns,
      reviewLengthStats,
      lengthColumns,
      ratingDistribution,
      ratingColumns,
      periodStats,
      periodColumns,
      hospitalReviewStats,
      hospitalReviewColumns,
      handleEventChange,
      downloadExcel,
      goBack
    };
  }
};
</script>

<style scoped lang="scss">
// 기본 레이아웃 스타일
.titleContainer {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.title-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
  width: 100%;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.event-filter-left {
  display: flex;
  align-items: center;
  
  .event-filter-row {
    display: flex;
    align-items: center;
    
    .label {
      font-weight: 600;
      color: #595959;
    }
    
    .event-select {
      min-width: 250px;
    }
  }
}

.page-title {
  color: #000;
  font-size: 1.8rem;
  margin: 0;
}

.pageDesc {
  font-size: 14px;
  color: #595959;
  margin-top: 8px;
  display: block;
}

.excel-button {
  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-right: 12px;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(56, 161, 105, 0.3);
    background: linear-gradient(135deg, #48bb78 0%, #38a169 100%) !important;
    color: white !important;
    border: none !important;
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(56, 161, 105, 0.2);
  }
}

.back-button {
  background-color: #f0f0f0;
  border: 1px solid #d9d9d9;
  color: #595959;
  
  &:hover {
    background-color: #e6e6e6;
    border-color: #d9d9d9;
    color: #595959;
  }
}

.card {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  border: none;
  overflow: hidden;
}

.content-wrap-card {
  margin-top: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fafafa;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  display: flex;
  align-items: center;
}

.content-section {
  padding: 40px 20px;
}

.loading-state {
  text-align: center;
  padding: 60px 20px;
  
  p {
    margin-top: 16px;
    font-size: 14px;
    color: #595959;
  }
}

// 후기 이벤트 전용 스타일
.review-summary-section {
  margin-bottom: 40px;
}

.stats-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    color: #666;
  }
}

.stats-subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
}

.review-stats-row {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  margin-bottom: 40px;
}

.stat-card {
  border-radius: 12px;
  padding: 24px 16px;
  text-align: center;
  color: white;
  position: relative;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 0.1) 100%);
    pointer-events: none;
  }
  
  &.purple {
    background: linear-gradient(135deg, #8b8ee5 0%, #7c7fdb 100%);
  }
  
  &.blue {
    background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  }
  
  &.green {
    background: linear-gradient(135deg, #52c41a 0%, #73d13d 100%);
  }
  
  &.orange {
    background: linear-gradient(135deg, #fa8c16 0%, #ffc53d 100%);
  }
  
  &.cyan {
    background: linear-gradient(135deg, #13c2c2 0%, #36cfc9 100%);
  }
  
  &.purple-light {
    background: linear-gradient(135deg, #b37feb 0%, #9254de 100%);
  }
}

.stat-number {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;
  line-height: 1.2;
  position: relative;
  z-index: 1;
}

.stat-desc {
  font-size: 13px;
  margin-bottom: 12px;
  opacity: 0.95;
  line-height: 1.3;
  position: relative;
  z-index: 1;
}

.stat-percent {
  font-size: 12px;
  font-weight: 500;
  opacity: 0.9;
  position: relative;
  z-index: 1;
}


// 후기 유형별 분석 스타일
.review-type-analysis-section {
  margin-bottom: 40px;
  
  .section-header {
    text-align: center;
    margin-bottom: 32px;
    padding: 24px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    color: white;
    
    .section-title {
      color: white;
      margin-bottom: 8px;
      font-size: 24px;
    }
    
    .section-desc {
      color: rgba(255, 255, 255, 0.9);
      margin: 0;
      font-size: 16px;
    }
  }
  
  .analysis-cards-row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }
  
  .analysis-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    transition: all 0.3s ease;
    
    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
      transform: translateY(-2px);
    }
    
    .card-header {
      padding: 16px 20px;
      border-bottom: 1px solid #f0f0f0;
      
      .card-title {
        color: white;
        margin: 0;
        font-size: 14px;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 5px 3px 5px 10px;
        
        i {
          font-size: 16px;
        }
      }
      
      &.quality-header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      }
      
      &.length-header {
        background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
      }
      
      &.rating-header {
        background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
      }
      
      &.period-header {
        background: linear-gradient(135deg, #fd79a8 0%, #fdcb6e 100%);
      }
    }
    
    .card-content {
      padding: 16px;
      
      :deep(.ant-table) {
        font-size: 12px;
        
        .ant-table-thead > tr > th {
          background: #fafafa;
          border-bottom: 1px solid #f0f0f0;
          padding: 8px 6px;
          font-size: 11px;
          font-weight: 600;
          color: #666;
        }
        
        .ant-table-tbody > tr > td {
          padding: 6px 6px;
          border-bottom: 1px solid #f5f5f5;
          font-size: 11px;
          
          &:first-child {
            font-weight: 500;
            color: #333;
          }
        }
        
        .ant-table-tbody > tr:hover > td {
          background: #f8faff;
        }
      }
    }
  }
}

// 병원별 후기 현황 스타일
.hospital-review-section {
  margin-bottom: 40px;
  
  .section-header-simple {
    margin-bottom: 24px;
    padding: 20px 24px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    text-align: center;
    
    .section-title {
      color: white;
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      
      i {
        font-size: 22px;
      }
    }
  }
  
  .hospital-table-content {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    
    .hospital-review-table {
      :deep(.ant-table) {
        .ant-table-thead > tr > th {
          background: #fafafa;
          border-bottom: 2px solid #f0f0f0;
          font-weight: 600;
          color: #333;
          text-align: center;
          
          &.ant-table-cell-fix-left {
            background: #f5f5f5;
            border-right: 1px solid #e8e8e8;
          }
        }
        
        .ant-table-tbody > tr {
          &:nth-child(even) {
            background: #fafafa;
          }
          
          &:hover > td {
            background: #f0f7ff !important;
          }
          
          td {
            border-bottom: 1px solid #f0f0f0;
            
            &.ant-table-cell-fix-left {
              background: inherit;
              border-right: 1px solid #e8e8e8;
              font-weight: 500;
            }
            
            &:not(.ant-table-cell-fix-left) {
              font-family: 'Courier New', monospace;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}

// 반응형 디자인
@media (min-width: 1920px) {
  .analysis-cards-row {
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }
  
  .review-stats-row {
    grid-template-columns: repeat(6, 1fr);
    gap: 14px;
  }
}

@media (max-width: 1200px) {
  .review-stats-row {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .analysis-cards-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .review-stats-row {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .analysis-cards-row {
    grid-template-columns: 1fr;
  }
  
}
</style>
